import { Outlet, NavLink, useLocation } from "react-router-dom";
import { Home, UserPlus, Award, Heart, MapPin, Info } from "lucide-react";
import Footer from "./common/Footer";

const navItems = [
  { path: "/", icon: Home, label: "Home" },
  { path: "/register", icon: UserPlus, label: "Register" },
  { path: "/sponsorship", icon: Award, label: "Sponsors" },
  { path: "/fundraising", icon: Heart, label: "Fundraise" },
  { path: "/venue", icon: MapPin, label: "Venue" },
  { path: "/info", icon: Info, label: "Info" },
];

export default function Layout() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-[#F9F8F4] pb-20 md:pb-0">
      {/* Desktop Header */}
      <header className="hidden md:block fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-lg border-b border-[#E6E2D6]">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex items-center justify-between h-16">
            <NavLink to="/" className="flex items-center gap-3" data-testid="logo-link">
              <div className="w-10 h-10 rounded-full bg-[#3A5F40] flex items-center justify-center">
                <span className="text-white font-semibold text-sm">BISN</span>
              </div>
              <span className="font-['Cormorant_Garamond'] text-xl text-[#1C1C1C]">
                BISN Golf Classic
              </span>
            </NavLink>
            <nav className="flex items-center gap-1">
              {navItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                  className={({ isActive }) =>
                    `px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                      isActive
                        ? "bg-[#3A5F40] text-white"
                        : "text-[#1C1C1C] hover:bg-[#F3F0E6]"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="md:pt-16">
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />

      {/* Mobile Bottom Nav */}
      <nav className="md:hidden bottom-nav">
        <div className="flex items-center justify-around py-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <NavLink
                key={item.path}
                to={item.path}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all duration-300 min-w-[60px] ${
                  isActive
                    ? "text-[#3A5F40] bg-[#3A5F40]/10"
                    : "text-[#666055] hover:text-[#3A5F40]"
                }`}
              >
                <item.icon size={20} strokeWidth={isActive ? 2.5 : 2} />
                <span className="text-xs font-medium">{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
